import { createContext } from 'react';

const organizations = [];
const formFields = [
    { id: 'form-name', name: 'name', label: 'Organisation', value: '' },
    { id: 'form-label', name: 'organizationType', label: 'Label', value: '' },
    { id: 'form-address', name: 'address', label: 'Adress', value: '' },
];
const layout = [
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Namn',
        filterValue: 'Name',
        textValue: 'name',
    },
    {
        width: 200,
        filterType: 'select',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Label',
        filterValue: 'Label',
        textValue: 'organizationType',
    },
    {
        width: 200,
        filterType: 'select',
        type: 'skill',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Teknisk Miljö',
        filterValue: 'Skill',
        textValue: 'skills',
    },
    {
        width: 200,
        filterType: 'select',
        type: 'list',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Ort',
        filterValue: 'Places',
        textValue: 'places',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: false,
        disabledFilter: true,
        textContent: 'Ort (övrigt)',
        filterValue: 'PlaceOther',
        textValue: 'placeOther',
    },
    {
        width: 200,
        filterType: 'text',
        type: 'text',
        disabledField: true,
        disabledFilter: true,
        textContent: 'Senaste Aktivitet',
        filterValue: 'LastActivityDate',
        textValue: 'lastActivityDate',
    },
    {
        width: 150,
        filterType: 'text',
        type: 'object',
        disabledField: false,
        disabledFilter: false,
        textContent: 'Ägare',
        filterValue: 'Owner',
        textValue: 'owner',
    },
];

export const initialState = {
    apiUrl: 'crmOrganizationFront',
    layout: layout,
    organizations: organizations,
    rows: organizations,
    activeOrganization: null,
    formFields: formFields,
    activityDealAlternatives: [],
    viewSettings: {
        minIndex: 0,
        maxIndex: 0,
        itemHeight: 40,
        totalHeight: 0,
        bufferHeight: 0,
        topPaddingHeight: 0,
        bottomPaddingHeight: 0,
        tolerance: 20,
    },
    requestObject: {
        startIndex: 0,
        amount: 30,
        tolerance: 20,
        filters: {},
    },
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'UPDATE_VIEW_SETTINGS_AND_REQUEST_OBJECT':
            return {
                ...state,
                viewSettings: action.viewSettings,
                requestObject: action.requestObject,
            };
        case 'UPDATE_VIEW_SETTINGS':
            return {
                ...state,
                viewSettings: action.viewSettings,
            };
        case 'UPDATE_REQUEST_OBJECT':
            return {
                ...state,
                requestObject: action.requestObject,
            };
        case 'UPDATE_DATA':
            return {
                ...state,
                organizations: action.payload,
                rows: action.payload,
            };
        case 'UPDATE_ACTIVE_ORGANIZATION':
            return {
                ...state,
                activeOrganization: action.payload,
            };
        case 'UPDATE_ORGANIZATIONS_AND_ACTIVE_ORGANIZATION':
            return {
                ...state,
                organizations: action.organizations,
                rows: action.organizations,
                activeOrganization: action.activeOrganization,
            };
        case 'UPDATE_FORM_FIELDS':
            return {
                ...state,
                formFields: action.payload,
            };
        case 'UPDATE_ACTIVITY_DEAL_ALTERNATIVES':
            return {
                ...state,
                activityDealAlternatives: action.payload,
            };
        default:
            return state;
    }
};

export const DataContext = createContext(initialState);
